import React, { useEffect } from "react";
import { draw } from "./draw";

export const SpiderChart = ({
  data,
  width,
  height,
  config,
  sref,
  setHoveredLabel,
}) => {
  height = height - 4;

  useEffect(() => {
    draw(sref.current, data, config, setHoveredLabel);
  }, [data, config, width, height, sref, setHoveredLabel]);

  return <svg ref={sref} width={width} height={height}></svg>;
};
